export default __webpack_public_path__ + "static/media/02.91738bdf.webp";